<section id="hotel_form">
  <article class="tw-flex tw-space-x-4 tw-justify-end" *ngIf="viewType !== 'new'" >
    <mh-core-lib-button
      [text]="'customer.configurations.hotel.add_new' | translate"
      [isSecondary]="true"
      routerLink="/customer/configuracion/hotel/new"
      *ngIf="canEdit"
      [width]="'auto'"
    ></mh-core-lib-button>
  </article>
  
  <div class="align_center">
    <mh-spinner-classic [hidden]="!waiting"></mh-spinner-classic>
  </div>

  <form class="general_set_form show_invalids" [formGroup]="hotelForm" #formDir="ngForm" *ngIf="!waiting">
    <!-- Tabs Navigation -->
    <div class="tw-w-full tw-mb-6">
      <!-- Contenedor principal con botones y tabs -->
      <div class="tw-relative">
        <!-- Contenedor de tabs -->
        <div class="tw-w-full tw-overflow-x-auto [&::-webkit-scrollbar]:hidden" #tabsContainer>
          <div class="tw-flex tw-border-b tw-border-gray-200 tw-min-w-max">
            <button type="button"
              *ngFor="let tab of visibleTabs"
              [ngClass]="{
                'tw-border-[#0F93CC] tw-text-[#0F93CC]': activeTab === tab.id,
                'tw-border-transparent tw-text-gray-500': activeTab !== tab.id,
                'tw-whitespace-nowrap': true
              }"
              class="tw-px-4 tw-py-2 tw-font-medium tw-border-b-2 tw-transition-colors hover:tw-text-[#0F93CC] focus:tw-outline-none tw-text-sm md:tw-text-base"
              (click)="setActiveTab(tab.id)">
              <span class="tw-hidden md:tw-inline">{{tab.label | translate}}</span>
              <span class="md:tw-hidden">{{(tab.label | translate).split(' ')[0]}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab Contents -->
    <div class="tw-mt-4">
      <!-- Información General Tab -->
      <div *ngIf="activeTab === 'general'" class="general_box">
        <section id="hotel_information">
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-4 logo_side">
                  <mh-core-lib-actions-wrapper
                      slug="company_settings_edit"
                    >
                    <mh-customer-hotel-images-form
                        [parentForm]="hotelForm"
                        [hotelDto]="hotelDto"
                        [hotelBase] = "hotel_base"
                        [viewType]="viewType"
                        [disabled]="!canEdit"
                        (waiting)="setUpdateElements($event)"
                        (isReady)="readyFormPart($event)">
                    </mh-customer-hotel-images-form>
                  </mh-core-lib-actions-wrapper>
                </div>
                <div class="col-8">
                  <mh-core-lib-actions-wrapper
                      slug="company_settings_edit"
                    >
                  <div class="row">
                    <ng-container *ngFor="let key of hotel_information">
                      <ng-container [ngSwitch]="key">
                        <ng-template [ngSwitchCase]="'web_site'">
                          <div class="col-12 tw-mb-3 tw-group" >
                            <input type="text" id="{{key}}" class="form-control group-hover:tw-cursor-pointer group-hover:tw-text-main-link tw-duration-150 tw-transition-colors" readonly  [value]="hotelDto?.web_site" (click)="goToWebsite()">
                          </div>
                        </ng-template>

                        <ng-template [ngSwitchCase]="(['country'].includes(key) ? key : false )">
                          <div class="col-6">
                            <widget-list-options
                              [label]= "'country'"
                              [name]="'hotel-form-select-'+key"
                              [list]="listOptions['countries']"
                              [selected]="hotelForm.controls[key].value?.code2"
                              [keyValue] = "'code2'"
                              [keyName] = "'code2'"
                              [prefixTranslate]="'countries'"
                              [disabled]="!isCompetitor"
                              [tooltip]="('customer.configurations.hotel.form.crm_tooltip' | translate)"
                              (select)="setSelectlValue($event,key)">
                            </widget-list-options>
                          </div>
                        </ng-template>

                        <ng-template [ngSwitchCase]="(['currency'].includes(key) ? key : false )">
                          <div class="col-6">
                            <widget-list-options
                              [label]= "('models.hotel_dto.'+key | translate)"
                              [name]="'hotel-form-select-'+key"
                              [list]="listOptions[key]"
                              [selected]="hotelForm.controls[key].value?.id"
                              [keyValue] = "'id'"
                              [keyName] = "'code'"
                              [disabled]="!canEdit"
                              (select)="setSelectlValue($event,key)">
                            </widget-list-options>
                          </div>
                        </ng-template>

                        <ng-template [ngSwitchCase]="(['language'].includes(key) ? key : false )">
                          <div class="col-6">
                            <widget-list-options
                              [label]= "'default_sent'"
                              [name]="'hotel-form-select-'+key"
                              [list]="listOptions[key]"
                              [selected]="hotelForm.controls[key].value?.id"
                              [keyValue] = "'id'"
                              [keyName] = "'code'"
                              [prefixTranslate] = "'languages.iso'"
                              [disabled]="!canEdit"
                              (select)="setSelectlValue($event,key)">
                            </widget-list-options>
                          </div>
                        </ng-template>


                        <ng-template [ngSwitchCase]="(['city'].includes(key) ? key : false )">
                          <div class="col-6">
                            <div class="inline">
                              <widget-list-options
                                [label]= "('models.hotel_dto.'+key | translate)"
                                [name]="'hotel-form-select-'+key"
                                [list]="listOptions['cities']"
                                [selected]="hotelForm.controls[key].value?.id"
                                [keyValue] = "'id'"
                                [keyName] = "'name'"
                                [disabled]="!isCompetitor"
                                [tooltip]="('customer.configurations.hotel.form.crm_tooltip' | translate)"
                                (select)="setSelectlValue($event,key)">
                              </widget-list-options>
                            </div>
                            <div class="inline" [class.invisible]="!changeCity">
                              <mh-spinner-classic></mh-spinner-classic>
                            </div>
                          </div>
                        </ng-template>

                        <ng-template [ngSwitchCase]="(['automatic_utc'].includes(key) ? key : false )">
                          <div class="col-6 wrapp_form">
                            <label for="{{key}}">{{'models.hotel_dto.'+key | translate}}</label>
                            <mat-slide-toggle id="{{key}}" class="form-switch"  formControlName="{{key}}" [checked]="hotelForm.controls[key].value" [id]="key" >
                              {{'commons.'+(hotelForm.controls[key].value ? 'yes' : 'no') | translate}}
                            </mat-slide-toggle>
                          </div>
                        </ng-template>

                        <ng-template [ngSwitchCase]="(['utc'].includes(key) ? key : false )">
                          <div class="col-6" [hidden]="hotelForm.controls.automatic_utc.value">
                            <widget-list-options
                              [label]= "('models.hotel_dto.'+key | translate)"
                              [name]="'hotel-form-select-'+key"
                              [list]="listOptions[key]"
                              [selected]="hotelForm.controls[key].value"
                              [disabled]="!canEdit"
                              [keyValue] = "'utc_miliseconds'"
                              [keyName] = "'utc_format'"
                              (select)="setSelectlValue($event,key)">
                            </widget-list-options>
                          </div>
                        </ng-template>



                        <ng-template ngSwitchDefault>
                          <div class="col-12 wrapp_form">
                            <div *ngIf="'name'.includes(key) && isSuperAdmin">
                              <span>
                                ID {{'commons.client' | translate}} <strong>{{hotel.id}}</strong>
                              </span>
                            </div>
                            <label for="{{key}}">
                              {{'models.hotel_dto.'+key | translate}}
                              <i *ngIf="defaultDisabledFields.includes(key)" 
                                 class="fas fa-question-circle tw-ml-1 tw-cursor-help" 
                                 [ngbTooltip]="('customer.configurations.hotel.form.crm_tooltip' | translate)" 
                                 container="body"
                                 placement="right"
                                 [autoClose]="false"></i>
                            </label>
                            <input type="text" id="{{key}}" class="form-control"  formControlName="{{key}}"  [attr.disabled]=" isCompetitor && defaultDisabledFields.includes(key) ? null : '' ">
                            <ng-container *ngTemplateOutlet="formAlerts;context:{element: hotelForm.controls[key]}"></ng-container>
                          </div>
                        </ng-template>
                      </ng-container>

                    </ng-container>
                  </div>
                  </mh-core-lib-actions-wrapper>

                  <div class="row tw-mt-20">

                    <div class="col-3">
                    <mh-core-lib-actions-wrapper
                        slug="company_settings_api_key_view"
                      >
                      <div class="apikey" [hidden]="showInputApiKey">
                        <mh-core-lib-button
                          [text]="('commons.see' | translate) + ' Access-Key'"
                          [isSecondary]="true"
                          [width]="'auto'"
                          (click)="showApiKey()"
                          [ngbTooltip]="('customer.configurations.hotel.tooltips.access_key' | translate)"
                          container="body"
                          type="button"
                        ></mh-core-lib-button>
                      </div>
                      <mat-form-field class="apikey" [hidden]="!showInputApiKey">
                        <label>Access-Key</label>
                        <input matInput value={{apiKey}} readonly="true" container="body"
                        [ngbTooltip]="('customer.configurations.hotel.tooltips.access_key' | translate)">
                      </mat-form-field>
                    </mh-core-lib-actions-wrapper>
                    </div>

                    <div class="col-9">
                    <mh-core-lib-actions-wrapper
                        slug="company_settings_api_documentation_view"
                      >
                      <div class="apikey">
                        <mh-core-lib-button
                          [text]="'commons.doc_api' | translate"
                          [isSecondary]="true"
                          [width]="'auto'"
                          (click)="goToDoc()"
                          container="body"
                        ></mh-core-lib-button>
                      </div>
                    </mh-core-lib-actions-wrapper>
                    </div>

                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>
      </div>

      <!-- Propiedades Tab -->
      <div *ngIf="activeTab === 'properties'" class="general_box tw-relative">
        <div *ngIf="customerAlertsExceptionsLoading" class="tw-absolute tw-h-full tw-w-full tw-bg-white/50 tw-z-50">
          <mh-core-lib-loader-wrapper 
            [type]="'spinner'"
            [loading]="customerAlertsExceptionsLoading"
            className="tw-self-center" 
            spinnerClassName="tw-text-[50px]">
          </mh-core-lib-loader-wrapper>
        </div>
        <section id="hotel_properties" *ngIf="isSuperAdmin">
          <div class="row">
            <div [class]="'col-' + getColClass(key) + ' wrapp_form'" *ngFor="let key of hotel_properties">
              <ng-container [ngSwitch]="key">
                <ng-template [ngSwitchCase]="(['default_checkin','default_checkout'].includes(key) ? key : false )">
                  <widget-list-options
                    class="tw-w-full"
                    [size]="'responsive'"
                    [label]= "('models.hotel_dto.'+key | translate)"
                    [name]="'hotel-form-select-'+key"
                    [list]="(['default_checkin','default_checkout'].includes(key) ? listOptions['hours'] : listOptions[key])"
                    [selected]="hotelForm.controls[key].value"
                    [disabled]="false"
                    (select)="setSelectlValue($event,key)">
                  </widget-list-options>
                </ng-template>



                <ng-template [ngSwitchCase]="(['tramo','licence_type'].includes(key) ? key : false )">
                  <widget-list-options
                    class="tw-w-full"
                    [size]="'responsive'"
                    [label]= "('models.hotel_dto.'+key | translate)"
                    [name]="'hotel-form-select-'+key"
                    [list]="listOptions[key]"
                    [selected]="hotelForm.controls[key].value"
                    [disabled]="!isCompetitor"
                    [tooltip]="('customer.configurations.hotel.form.crm_tooltip' | translate)"
                    (select)="setSelectlValue($event,key)">
                  </widget-list-options>

                </ng-template>

                <ng-template [ngSwitchCase]="(['stage'].includes(key) ? key : false )">
                  <div *ngIf="isSuperAdmin">
                    <widget-list-options
                        class="tw-w-full"
                        [size]="'responsive'"
                        [label]="('models.hotel_dto.'+key | translate)"
                        [name]="'hotel-form-select-'+key"
                        [list]="listOptions[key]"
                        [selected]="hotelForm.controls[key]?.value?.id"
                        [keyValue]="'id'"
                        [keyName]="'name'"
                        [disabled]="false"
                        (select)="setSelectlValue($event,key)">
                    </widget-list-options>
                </div>
                </ng-template>

                <ng-template [ngSwitchCase]="(['property_type'].includes(key) ? key : false )">
                  <widget-list-options
                    class="tw-w-full"
                    [size]="'responsive'"
                    [name]="'testing'"
                    [label]= "'label'"
                    [list]="listOptions[key]"
                    [selected]="hotelForm.controls[key].value?.id"
                    [disabled]="false"
                    [keyName]="'id'"
                    [keyValue]="'id'"
                    [prefixTranslate]="'models.hotel_dto.'+key"
                    (select)="setSelectlValue($event,key)">
                  </widget-list-options>
                </ng-template>

                <ng-template [ngSwitchCase]="(['seasonal'].includes(key) ? key : false )">
                  <div class="tw-flex tw-flex-col tw-gap-2">
                    <label for="{{key}}" class="tw-font-medium tw-text-sm">{{'models.hotel_dto.'+key | translate}}</label>
                    <mh-core-lib-toggle 
                      [id]="key" 
                      [name]="key"
                      formControlName="{{key}}" 
                      [label]="'commons.'+(hotelForm.controls[key].value ? 'yes' : 'no') | translate"
                      [labelPosition]="'horizontal'">
                    </mh-core-lib-toggle>
                  </div>
                </ng-template>

                <ng-template [ngSwitchCase]="(['rooms_quantity','pipedrive_id', 'id_xero', 'hubspot_id'].includes(key) ? key : false )">
                  <ng-container *ngIf="key === 'pipedrive_id'">
                    <mh-core-lib-button
                      [text]="'customer.configurations.hotel.see_in_pipedrive' | translate"
                      [isSecondary]="true"
                      [isDisabled]="isPipedriveDisabled"
                      (click)="handlePipedriveButton()"
                      [width]="'auto'"
                    ></mh-core-lib-button>
                  </ng-container>
                  <ng-container *ngIf="key === 'hubspot_id'">
                    <mh-core-lib-button
                      [text]="'customer.configurations.hotel.see_in_hubspot' | translate"
                      [isSecondary]="true"
                      [isDisabled]="ishHubspotDisabled"
                      (click)="handleHubspotButton()"
                      [width]="'auto'"
                    ></mh-core-lib-button>
                  </ng-container>
                  <ng-container *ngIf="key === 'id_xero'">
                    <mh-core-lib-button
                      [text]="'customer.configurations.hotel.see_in_xero' | translate"
                      [isSecondary]="true"
                      [isDisabled]="isXeroDisabled"
                      (click)="handleXeroButton()"
                      [width]="'auto'"
                    ></mh-core-lib-button>
                  </ng-container>
                </ng-template>

                <ng-template [ngSwitchCase]="(['flag_show_translations', 'alerts_warning', 'alerts_blocking'].includes(key) ? key : false )">
                  <ng-container *ngIf="key === 'flag_show_translations'">
                    <div class="tw-flex tw-flex-col tw-gap-2">
                      <label for="{{key}}" class="tw-font-medium tw-text-sm">{{'models.hotel_dto.'+key | translate}} 
                        <i class="fas fa-question-circle tw-ml-1 tw-cursor-help" 
                           [ngbTooltip]="('configuration.tooltips.review_translates' | translate)" 
                           container="body"
                           placement="right"
                           [autoClose]="false"></i>
                      </label>
                      <mh-core-lib-toggle 
                        [id]="key" 
                        [name]="key"
                        formControlName="{{key}}" 
                        [label]="'commons.'+(hotelForm.controls[key].value ? 'yes' : 'no') | translate"
                        [labelPosition]="'horizontal'">
                      </mh-core-lib-toggle>
                    </div>
                  </ng-container>
                  
                  <ng-container *ngIf="key === 'alerts_warning' || key === 'alerts_blocking'">
                    <div class="tw-flex tw-flex-col tw-gap-2">
                      <label for="{{key}}" class="tw-font-medium tw-text-sm">{{'models.hotel_dto.'+key | translate}} 
                        <i class="fas fa-question-circle tw-ml-1 tw-cursor-help" 
                           [ngbTooltip]="('configuration.tooltips.' + key | translate)" 
                           container="body"
                           placement="right"
                           [autoClose]="false"></i>
                      </label>
                      <mh-core-lib-toggle 
                        [id]="key" 
                        [name]="key"
                        [formControl]="hotelFormAlerts.controls[key]"
                        [label]="'commons.'+(hotelFormAlerts.controls[key].value ? 'yes' : 'no') | translate"
                        [labelPosition]="'horizontal'">
                      </mh-core-lib-toggle>
                    </div>
                  </ng-container>
                </ng-template>

                <ng-template [ngSwitchCase]="(['commercial_executive', 'cs_executives'].includes(key) ? key : false)">
                  <widget-list-options
                    class="tw-w-full"
                    [size]="'responsive'"
                    [name]="key"
                    [list]="listOptions[key]"
                    [selected]="hotelForm.controls[key].value"
                    [keyName]="'name'"
                    [keyValue]="'id'"
                    [label]="('models.hotel_dto.'+key | translate)"
                    [disabled]="!isCompetitor"
                    [tooltip]="('customer.configurations.hotel.form.crm_tooltip' | translate)"
                    (select)="setSelectlValue($event, key)"
                    ></widget-list-options>
                </ng-template>

                <ng-template ngSwitchDefault>
                  <div class="row no-gutters input-no-padding">
                    <mat-form-field appearance="fill" class="tw-w-full">
                      <label class="tw-w-max" for="{{key}}">
                        {{'models.hotel_dto.'+key | translate}}
                        <i *ngIf="defaultDisabledFields.includes(key)" 
                           class="fas fa-question-circle tw-ml-1 tw-cursor-help" 
                           [ngbTooltip]="('customer.configurations.hotel.form.crm_tooltip' | translate)" 
                           container="body"
                           placement="right"
                           [autoClose]="false"></i>
                      </label>
                      <input 
                        matInput
                        type="text" 
                        id="{{key}}" 
                        formControlName="{{key}}" 
                        [ngClass]="{'!tw-bg-[#e9ecef]': !isCompetitor && defaultDisabledFields.includes(key)}" 
                        [attr.disabled]=" isCompetitor && defaultDisabledFields.includes(key) ? null : '' " 
                      >
                    </mat-form-field>
                  </div>
                </ng-template>
              </ng-container>

              <ng-container *ngTemplateOutlet="formAlerts;context:{element: hotelForm.controls[key]}"></ng-container>
            </div>
          </div>
        </section>
      </div>

      <!-- Productos Tab -->
      <div *ngIf="activeTab === 'products'" class="general_box">
        <section id="hotel_products" *ngIf="isSuperAdmin">
          <div class="row">
            <div class="col-4 wrapp_form" *ngFor="let key of hotel_products">
              <div class="tw-flex tw-flex-col tw-gap-2">
                <label for="{{key}}" class="tw-font-medium tw-text-sm">{{'models.hotel_dto.'+key | translate}}</label>
                <mh-core-lib-toggle 
                  [id]="key" 
                  [name]="key"
                  formControlName="{{key}}" 
                  [label]="'commons.'+(hotelForm.controls[key].value ? 'yes' : 'no') | translate"
                  [labelPosition]="'horizontal'"
                  (onClick)="setProductsToActive(key)">
                </mh-core-lib-toggle>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- Cadena Hotelera Tab -->
      <div *ngIf="activeTab === 'chain'" class="general_box">
        <section id="hotel_chain_property" *ngIf="isSuperAdmin">
          <mh-customer-hotel-chain-form
            [parentForm]="hotelForm"
            [hotelDto]="hotelDto"
            [hotelBase] = "hotel_base"
            [listOptions] = "listOptions"
            [canEdit]="canEdit"
            (waiting)="setUpdateElements($event)"
            (isReady)="readyFormPart($event)">
          </mh-customer-hotel-chain-form>
        </section>
      </div>

      <!-- Contacto Huéspedes Tab -->
      <div *ngIf="activeTab === 'contact'" class="general_box">
        <section id="guest_contact">
          <mh-info-contact-guest [customer_id]="customer_id" #InfoContactGuest>
          </mh-info-contact-guest>
        </section>
      </div>

      <!-- Áreas Tab -->
      <div *ngIf="activeTab === 'areas'" class="general_box">
        <section id="hotel_areas" *ngIf="isSuperAdmin || isAdmin">
          <mh-areas-manager [customer_id]="customer_id" #AreasManager>
          </mh-areas-manager>
        </section>
      </div>

      <!-- OTAs Tab -->
      <div *ngIf="activeTab === 'others'" class="general_box">
        <section id="hotel_otas" *ngIf="isSuperAdmin && canEdit && viewType==='edit'">
          <mh-forms-dialog
            [title]="('customer.configurations.hotel.others.otas' | translate)"
            [actionText]="('customer.configurations.hotel.others.otas' | translate)"
            [showButtonYes]="false"
            [modalSize]="'lg'"
            [showButtonNo]="false">
            <admin-configuration-otas
              [hotel]="hotel"
            ></admin-configuration-otas>
          </mh-forms-dialog>
        </section>
      </div>

      <!-- GDPR Tab -->
      <div *ngIf="activeTab === 'gdpr'" class="general_box">
        <section id="hotel_gdpr" *ngIf="isSuperAdmin">
          <mh-hotel-gdpr-retention #hotelGdprRetention [customer_id]="customer_id"></mh-hotel-gdpr-retention>
        </section>
      </div>
    </div>

    <!-- Botón de guardar -->
    <div class="bottom tw-mt-6" *ngIf="canEdit || canEditByTab || isSuperAdmin || isAdmin">
      <mh-core-lib-button
        [text]="'forms.save_changes' | translate"
        [isPrimary]="true"
        [isDisabled]="
          hotelForm.invalid ||
          waitingElements ||
          waitingSave ||
          (guestContactForm?.invalid ?? false) ||
          (activeTab === 'gdpr' && hotelGdprRetention?.gdprForm?.invalid)
        "
        [hidden]="(activeTab === 'general' && !isSuperAdmin)"
        (click)="saveData()"
        type="submit"
        [width]="'auto'"
      ></mh-core-lib-button>
      <mh-spinner-classic [hidden]="!waitingSave"></mh-spinner-classic>
    </div>
  </form>
</section>

<ng-template #formAlerts let-element="element">
  <ng-container *ngIf="element">
    <small class="alert-danger">
      <ng-container  *ngIf="element.invalid && (element.dirty || element.touched)" >
        <div *ngIf="element.errors.required">
          {{'forms.attributes.not_empty' | translate}}
        </div>
        <div *ngIf="element.errors.minlength">
          {{'forms.attributes.min_lenght' | translate:({length: element.errors.minlength.requiredLength})}}
        </div>

        <div *ngIf="element.errors.maxlength">
          {{'forms.attributes.max_lenght' | translate:({length: element.errors.maxlength.requiredLength})}}
        </div>
      </ng-container>
    </small>
  </ng-container>
</ng-template>

<ng-template #formTypes let-data="data">

</ng-template>








